import dayjs from "dayjs";
import Litepicker from "litepicker";
import "./timepicker"

(function () {
    "use strict";

    let datepickers = $(".datepicker");

    datepickers.each(function () {
        let options = {
            buttonText: {
                apply: "Seleccionar",
                cancel: "Cancelar"
            },
            position: "auto",
            autoApply: false,
            autoRefresh: false,
            singleMode: false,
            maxDate: null,
            minDate: null,
            startDate: null,
            numberOfColumns: 2,
            numberOfMonths: 2,
            format: "D MMM, YYYY",
            lang: "es-MX",
            dropdowns: {
                minYear: 1990,
                maxYear: null,
                months: true,
                years: true,
            },
        };

        if ($(this).data("single-mode")) {
            options.singleMode = true;
            options.numberOfColumns = 1;
            options.numberOfMonths = 1;
        }

        if ($(this).data("format")) {
            options.format = $(this).data("format");
        }

        if ($(this).data("max-date")) {
            options.maxDate = $(this).data("max-date");
        }

        if ($(this).data("min-date")) {
            options.minDate = $(this).data("min-date");
        }

        if ($(this).data("dropdown-max-year")) {
            options.dropdowns.maxYear = $(this).data("dropdown-max-year");
        }

        if ($(this).data("dropdown-min-year")) {
            options.dropdowns.minYear = $(this).data("dropdown-min-year");
        }

        if ($(this).data("position")) {
            options.position = $(this).data("position");
        }

        if ($(this).data("min-days")) {
            options.minDays = $(this).data("min-days");
        }

        if ($(this).is("[data-reset-button]")) {
            options.resetButton = () => {
                let btn = document.createElement('button');
                btn.classList.add('absolute','border','border-2','right-0','btn')
                btn.style.top = "-2.5rem"
                btn.style.background = "#2D3C5A80"
                btn.style.color = "white"
                btn.innerHTML = '<i class="fa-solid fa-clock-rotate-left"></i>';

                return btn;
             }
        }

        if ($(this).is("[data-auto-apply]")) {
            options.autoApply = true;
        }

        if ($(this).is("[data-lock-sundays]")) {
            options.lockDaysFilter = (day) => {
                const d = day.getDay();
                return d === 0;
             };
        }

        if ($(this).is("[data-auto-refresh]")) {
            options.autoRefresh = true;
        }

        if ($(this).val()) {
            options.startDate = $(this).val();
        } else {
            let date = dayjs().format(options.format);
            date += !options.singleMode
                ? " - " + dayjs().add(1, "month").format(options.format)
                : "";
            $(this).val(date);
        }

        const datepicker = new Litepicker({
            element: this,
            ...options,
        });

        datepicker.on('selected', (date) => {
            this.dispatchEvent(new CustomEvent('selected', { detail: date }));
        });

        datepicker.on('clear:selection', () => {
            this.dispatchEvent(new CustomEvent('date-reset'));
        });

        this.__datepicker = datepicker;

    });
})();
